// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.reporting.admin.MipsQualityReportRequest */
/* istanbul ignore next */
@GandalfModel
export class MipsQualityReportRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.CqmSearchTypes)
	@GandalfValidator({ notNull: { message: 'Type is Required' } })
	@GandalfProperty({ designType: constants.CqmSearchTypes, isRequired: true })
	cqmSearchType!: constants.CqmSearchTypes;

	@GandalfValidator({ notNull: { message: 'End Date is Required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	endDate!: Date;

	@GandalfValidator({ notNull: { message: 'Location Tax Id is Required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationTaxId!: number;

	@GandalfProperty({ designType: Number })
	providerId!: number | null;

	@GandalfValidator({ notNull: { message: 'Start Date is Required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	startDate!: Date;

}
